import { useState } from 'react'
import classNames from 'classnames'

import { getImageFileThumbnail } from '../../../utils/file'
import { Avatar } from '../../Avatar'
import { ICON_HEIGHT_24 } from '../../Icon'
import { FileIconPlaceholder } from '../FileIconPlaceholder'

import * as styles from './FileIconThumbnail.module.css'

function FileIconThumbnail({
  className,
  file,
  size = ICON_HEIGHT_24,
  ...restProps
}) {
  const [errorSrc, setErrorSrc] = useState(null)

  const src = getImageFileThumbnail({ file })

  function handleError() {
    setErrorSrc(src)
  }

  return errorSrc === src ? (
    <FileIconPlaceholder
      {...restProps}
      className={className}
      file={file}
      size={size}
    />
  ) : (
    <Avatar
      alt={file.filename || file.name}
      className={classNames(
        styles.fileIconThumbnail,
        {
          [styles[`size${size}`]]: styles[`size${size}`],
        },
        className
      )}
      imageProps={{ loading: 'lazy', onError: handleError }}
      size={size}
      src={src}
    />
  )
}

export default FileIconThumbnail
